import { Button, Card, Input } from "antd";
import dayjs from "dayjs";
import { useState } from "react";
import { Comment } from "../../../types/comments";
import styles from "./CardComments.module.scss";

type Props = {
  comments: Comment[] | undefined;
  onAddComment: (values: { description: string }) => Promise<void>;
  isSubmitting: boolean;
  className?: string;
};

const CardComments: React.FC<Props> = ({
  comments,
  onAddComment,
  isSubmitting,
  className,
}) => {
  const [description, setDescription] = useState("");

  const handleSubmit = async () => {
    if (!description.trim()) return;
    await onAddComment({ description: description.trim() });
    setDescription("");
  };

  return (
    <Card title="Commentaires" bordered={false} className={className}>
      <div className={styles.commentsList}>
        {comments?.length ? (
          comments.map((comment) => (
            <div key={comment.id} className={styles.commentItem}>
              <div className={styles.commentHeader}>
                <span className={styles.commentAuthor}>
                  {comment.creator?.fullname ?? "Inconnu"}
                </span>
                {comment.creator?.cached_role?.displayName && (
                  <span className={styles.commentRole}>
                    {comment.creator.cached_role.displayName}
                  </span>
                )}
                <span className={styles.commentDate}>
                  {dayjs(comment.dateCreated).format("DD/MM/YYYY HH:mm")}
                </span>
              </div>
              <p className={styles.commentDescription}>{comment.description}</p>
            </div>
          ))
        ) : (
          <p className="text-light-grey">Aucun commentaire.</p>
        )}
      </div>
      <div className={styles.addComment}>
        <Input.TextArea
          rows={3}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="Ajouter un commentaire..."
          disabled={isSubmitting}
        />
        <Button
          type="primary"
          onClick={handleSubmit}
          loading={isSubmitting}
          disabled={!description.trim()}
          style={{ marginTop: 8 }}
        >
          Ajouter
        </Button>
      </div>
    </Card>
  );
};

export default CardComments;
